import { type i18n } from 'i18next';
import { eventChannel, END } from 'redux-saga';
import { languageChanged } from './events';

export const createLanguageChangeChannel = (instance: i18n) =>
  eventChannel<ReturnType<typeof languageChanged>>((emit) => {
    const callback = (payload: string) => {
      emit(languageChanged(payload));
    };

    instance.on('languageChanged', callback);

    return () => {
      instance.off('languageChanged', callback);

      emit(END);
    };
  });
